import * as React from 'react';

function SvgEditFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M29 8.83A9 9 0 0023.17 3l-.57-.17-4 4 6.53 6.53 4-4zM17.2 8.28L4 21.48V28h6.53l13.2-13.2-6.53-6.52z" />
    </svg>
  );
}

export default SvgEditFilled;
